import { Injectable } from '@angular/core';

@Injectable()
export class BrowserDetectionService {
  static UA = navigator.userAgent.toLowerCase();

  static isIE(): any {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
  }

  static isOpera(): boolean {
    return /opera/.test(BrowserDetectionService.UA);
  }

  static isChrome(): boolean {
    return /\bchrome\b/.test(BrowserDetectionService.UA);
  }

  static isWebKit(): boolean {
    return /webkit/.test(BrowserDetectionService.UA);
  }

  static isSafari(): boolean {
    return !BrowserDetectionService.isChrome() && /safari/.test(BrowserDetectionService.UA);
  }

  static isGecko(): boolean {
    return !BrowserDetectionService.isWebKit() && /gecko/.test(BrowserDetectionService.UA);
  }

  static isWindows(): boolean {
    return /windows|win32/.test(BrowserDetectionService.UA);
  }

  static isMac(): boolean {
    return /macintosh|mac os x/.test(BrowserDetectionService.UA);
  }

  static isLinux(): boolean {
    return /linux/.test(BrowserDetectionService.UA);
  }

  static isSecure(): boolean {
    return /^https/i.test(window.location.protocol);
  }

  constructor() {}
}
